
export namespace EmailUtil {
    export function emailAddressIsValid(emailAddress: string): boolean {
        const emailPattern = new RegExp( /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/gi);
        return emailAddress !== undefined && emailPattern.test(emailAddress);
    }
}
